/* Shares DataTable's palette so a page mixing the two reads as one product:
   same header fill, same cell rule, same delta colours. What differs is that
   these columns size themselves — a competitor board and a PO list do not have
   the same shape twice. */
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  line-height: 18px;
}

.table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 9px 12px;
  background: var(--bg-table-header);
  color: var(--text-header);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
}
.table thead th:first-child { border-top-left-radius: 6px; }
.table thead th:last-child { border-top-right-radius: 6px; }

.headInner { display: inline-flex; align-items: center; gap: 4px; }

.table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--border-cell);
  color: var(--text-value);
  vertical-align: middle;
}
.table tbody tr:last-child td { border-bottom: 0; }

.alignLeft { text-align: left; }
.alignRight { text-align: right; }
.alignCenter { text-align: center; }

.cellValue { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.alignLeft .cellValue { white-space: normal; }

.cellSub {
  display: block;
  margin-top: 2px;
  color: var(--text-muted);
  font-size: 11px;
  line-height: 14px;
}
.up { color: var(--delta-up); }
.down { color: var(--delta-down); }
.muted { color: var(--text-muted); }

.clickable { cursor: pointer; }
.clickable:hover td { background: var(--bg-pill); }
.clickable:focus-visible { outline: 2px solid #342885; outline-offset: -2px; }
.selected td { background: var(--bg-row-selected); }

.skeleton {
  display: inline-block;
  width: 100%;
  max-width: 84px;
  height: 12px;
  border-radius: 3px;
  background: linear-gradient(90deg, #f2f4f7 25%, #e9edf3 37%, #f2f4f7 63%);
  background-size: 400% 100%;
  animation: shimmer 1.3s ease-in-out infinite;
}
@keyframes shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

.empty {
  padding: 18px 2px;
  color: var(--text-muted);
  font-size: 13px;
  line-height: 19px;
}

.tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: var(--radius-pill);
  font-size: 11px;
  font-weight: 500;
  line-height: 15px;
  white-space: nowrap;
}
.tag_neutral { background: var(--bg-pill); color: var(--text-pill); }
.tag_good { background: var(--badge-low-bg); color: var(--badge-low-text); }
.tag_warn { background: rgb(255 204 0 / 14%); color: var(--badge-med-text); }
.tag_bad { background: rgb(239 62 62 / 12%); color: var(--badge-high-text); }

.srOnly {
  position: absolute;
  width: 1px; height: 1px;
  padding: 0; margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

/* ---- sorting and search ------------------------------------------------ */
.tools { display: flex; align-items: center; gap: 10px; margin: 0 0 10px; }
.search {
  flex: 0 1 260px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--header-border, #e0e0e0);
  border-radius: 7px;
  font-size: 12.5px;
  outline: none;
}
.search:focus { border-color: #7c5cff; }
.count { font-size: 11.5px; color: var(--header-text-muted, #8f8f91); }

/* The whole header cell is the target — the user asked for the action, not an
   icon, so there is no separate affordance to hit. */
.sortable { cursor: pointer; user-select: none; }
.sortable:hover { background: rgba(0, 0, 0, 0.04); }
.sorted { font-weight: 700; }
.caret { margin-left: 4px; font-size: 9px; opacity: 0.75; }
